type CountryFormatOptions = {
  monthFirst?: boolean
  am?: boolean
  sep?: string
}

const COUNTRY_MOMENT_FORMATS: Record<string, CountryFormatOptions> = {
  us: { monthFirst: true, am: true },
  ca: { monthFirst: true, am: true },
  ph: { monthFirst: true, am: true },
  mx: { monthFirst: true, am: true },
  de: { sep: '.' },
  pl: { sep: '.' },
  default: {},
}

type I18nForMomentFormats = {
  global: {
    t: (key: string) => string
  }
}

export function generateMomentFormats (
  { monthFirst = false, am = false, sep = '/' }: CountryFormatOptions,
  i18n: I18nForMomentFormats
) {
  const long = (monthFirst) ? 'MMM D, YYYY' : 'D MMM YYYY'
  const longest = `ddd, ${long}`
  const ddd_D_MMM = 'ddd, D MMM'

  return {
    h_a: (am) ? 'h a' : 'H:mm',
    hm_A: (am) ? 'h:mm A' : 'H:mm',
    hm: (am) ? 'h:mm' : 'H:mm',
    A: (am) ? 'A' : '',
    ddd_D: 'ddd D',
    ddd: 'ddd',
    dddd: 'dddd',
    D: 'D',
    MMM_D: (monthFirst) ? 'MMM D' : 'D MMM',
    EXPIRES_MM_YY: 'MM/YY',
    EXPIRES_MM_YYYY: 'MM/YYYY',
    MMM_DD_YYYY: monthFirst ? 'MMM DD, YYYY' : 'DD MMM, YYYY',

    // from web-biz
    shortHour: (am) ? 'h:mm' : 'H:mm',
    ddd_D_MMM,
    ddd_D_MMMM: 'ddd, D MMMM',
    MMM_D_YYYY: long,
    ddd_MMM_D_YYYY: longest,
    MM_DD_YYYY: (monthFirst) ? `MM${sep}DD${sep}YYYY` : `DD${sep}MM${sep}YYYY`,
    MMMM_YYYY: 'MMMM YYYY',
    MMMM_D_ORDINAL: (monthFirst) ? 'MMMM Do' : 'D MMMM',
    MMMM_D: (monthFirst) ? 'MMMM D' : 'D MMMM',
    MMMM_D_YYYY: (monthFirst) ? 'MMMM D YYYY' : 'D MMMM YYYY',
    YYYY_MM_DD: (monthFirst) ? 'MM-DD-YYYY' : 'YYYY-MM-DD',
    MMM_D_YYYY_hm_A: am ? `${long}, h:mm A` : `${long}, H:mm`,
    ddd_MMM_D_YYYY_hm_A: am ? `${longest}, h:mm A` : `${longest}, H:mm`,
    calendar: {
      sameDay: `[${i18n.global.t('today')}]`,
      nextDay: ddd_D_MMM,
      lastDay: ddd_D_MMM,
      nextWeek: ddd_D_MMM,
      lastWeek: ddd_D_MMM,
      sameElse: ddd_D_MMM,
    },
  }
}

export function getMomentFormats (country: string, i18n: I18nForMomentFormats) {
  return generateMomentFormats(
    COUNTRY_MOMENT_FORMATS[country] || COUNTRY_MOMENT_FORMATS.default,
    i18n
  )
}
